import React, { useEffect, useState } from 'react';
import './CircularProgress.css';

interface Prop {
  progress?: number;
  size?: number;
  strokeWidth?: number;
  circleColor?: string;
  progressColor?: string;
  textColor?: string;
  animate?: boolean;
  animationDuration?: number;
  showPercentage?: boolean;
  children?: any;
}

const CircularProgress: React.FC<Prop> = ({
  progress = 0, // 进度值 (0-100)
  size = 120, // 组件大小 (像素)
  strokeWidth = 10, // 进度条宽度
  circleColor = '#e6e6e6', // 背景圆颜色
  progressColor = '#3b82f6', // 进度条颜色
  textColor = '#333', // 文字颜色
  animate = true, // 是否启用动画
  animationDuration = 1, // 动画时长 (秒)
  showPercentage = true, // 是否显示百分比
  children, // 自定义内容
}: Prop) => {
  const [animatedProgress, setAnimatedProgress] = useState(0);

  // 半径计算 (考虑 strokeWidth)
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  // 根据进度计算 stroke-dashoffset
  const progressOffset =
    circumference - (animatedProgress / 100) * circumference;

  // 处理进度动画
  useEffect(() => {
    if (!animate) {
      setAnimatedProgress(progress);
      return;
    }

    let start = null;
    const duration = animationDuration * 1000; // 转换为毫秒

    const animateProgress = (timestamp) => {
      if (!start) start = timestamp;
      const elapsed = timestamp - start;
      const progressAmount = Math.min(elapsed / duration, 1);

      setAnimatedProgress(progressAmount * progress);

      if (progressAmount < 1) {
        requestAnimationFrame(animateProgress);
      }
    };

    requestAnimationFrame(animateProgress);
  }, [progress, animate, animationDuration]);

  return (
    <div
      className="circular-progress-container"
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        className="circular-progress-svg"
      >
        {/* 背景圆 */}
        <circle
          className="progress-bg"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          stroke={circleColor}
          fill="none"
        />

        {/* 进度圆 */}
        <circle
          className="progress-circle"
          cx={size / 2}
          cy={size / 2}
          r={radius}
          strokeWidth={strokeWidth}
          stroke={progressColor}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={progressOffset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{
            transition: animate
              ? `stroke-dashoffset ${animationDuration}s ease`
              : 'none',
          }}
        />
      </svg>

      {/* 中心内容 */}
      {/* <div className="circular-progress-content">
        {children ? (
          children
        ) : showPercentage ? (
          <span className="circular-progress-text" style={{ color: textColor }}>
            {Math.round(animatedProgress)}%
          </span>
        ) : null}
      </div> */}
    </div>
  );
};

export default CircularProgress;
